import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "electric-wrapper flex justify-center items-baseline gap-4" }
const _hoisted_2 = { class: "hours" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "colon" }, ":", -1)
const _hoisted_4 = { class: "minutes" }
const _hoisted_5 = { class: "seconds" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.time.split(':')[0]), 1),
    _hoisted_3,
    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.time.split(':')[1]), 1),
    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.time.split(':')[2]), 1)
  ]))
}